var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOnlyLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 489,
    viewBox: "0 0 489 489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 489,
    height: 489,
    rx: 110.222,
    fill: "url(#paint0_linear_78_930)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.847 221.649L171.129 140.065C163.084 135.865 154.635 144.922 159.365 152.663L202.472 223.269C208.266 232.755 218.587 238.548 229.693 238.548H323.698C333.058 238.548 336.145 225.975 327.822 221.649H327.847Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M327.847 268.223L171.129 349.808C163.084 354.007 154.635 344.95 159.365 337.209L202.472 266.604C208.266 257.117 218.587 251.324 229.693 251.324H323.698C333.058 251.324 336.145 263.897 327.822 268.223H327.847Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_930",
    x1: 244.5,
    y1: 0,
    x2: 244.5,
    y2: 489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88BFFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyLetter);
export default __webpack_public_path__ + "static/media/logoOnlyLetter.3514af0959ceeae3dcd168dac8ff6c2c.svg";
export { ForwardRef as ReactComponent };